import { Alert, Box, Chip, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { adminGetCustomers } from '../../api/adminApi';
import { useAdminAuth } from '../../Context/AdminAuthContext';

export default function AdminCustomers() {
    const { token } = useAdminAuth();
    const [customers, setCustomers] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!token) return;
        adminGetCustomers(token)
            .then(setCustomers)
            .catch(e => setError(e.message))
            .finally(() => setLoading(false));
    }, [token]);

    return (
        <Box>
            <Typography variant="h5" fontWeight={700} mb={3}>Customers</Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {loading ? <CircularProgress /> : (
                <Table size="small" sx={{ bgcolor: 'white', borderRadius: 1 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Cell</TableCell>
                            <TableCell>Tenant</TableCell>
                            <TableCell>Policy Accepted</TableCell>
                            <TableCell>Created</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customers.map(c => (
                            <TableRow key={c.id} hover>
                                <TableCell>{c.name} {c.surname}</TableCell>
                                <TableCell>{c.email}</TableCell>
                                <TableCell>{c.cell}</TableCell>
                                <TableCell>{c.tenantName}</TableCell>
                                <TableCell>
                                    <Chip label={c.policyAccepted ? 'Yes' : 'No'} color={c.policyAccepted ? 'success' : 'default'} size="small" />
                                </TableCell>
                                <TableCell>{new Date(c.createdAt).toLocaleDateString()}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Box>
    );
}
